import $ from 'jquery';
import * as bootstrap from 'bootstrap';
import jBob from 'jbob';

window.jQuery = window.$ = $;
window.bootstrap = bootstrap;

var j = new jBob();
window.j = j;
